/**
 * Query keys for Amenity API hooks
 *
 * Centralized query keys enable consistent cache invalidation across all amenity hooks.
 *
 * Usage:
 *   import { amenityQueryKeys } from '~/hooks/apis/amenities/amenityQueryKeys';
 */

export const amenityQueryKeys = {
  all: ['amenities'] as const,
  lists: () => [...amenityQueryKeys.all, 'list'] as const,
  list: (filters?: { groupId?: string }) => [...amenityQueryKeys.lists(), filters] as const,
  details: () => [...amenityQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...amenityQueryKeys.details(), id] as const,
  groups: () => [...amenityQueryKeys.all, 'groups'] as const,
  group: (id: string) => [...amenityQueryKeys.groups(), id] as const,
};
